import IconLogoViolation from "~/assets/img/alert-triangle.png";
import IconLogoCenter from "~/assets/img/authorization_center.png";
import IconBaseStaff from "~/assets/img/BaseStaff.png";
import IconLogoGR from "~/assets/img/global_rating.png";
import IconLogoInfoSystem from "~/assets/img/infoSystemGuide.png";
import IconLogoStaff from "~/assets/img/personal.png";
import IconLogoQ from "~/assets/img/quartiles.png";
import IconLogoCatalogEducationalPrograms from "~/components/Icons/hardbound-book-icon";
import IconLogoPositionsDirectory from "~/components/Icons/icon-employee";
import IconLogoSubdivision from "~/components/Icons/icon-piramid";
import NewFiles from "~/components/Icons/NewFiles";
import VideoCamera from "~/components/Icons/VideoCamera";

export const OPTIONS = [
  {
    id: 1,
    code: "GR",
    name: "GR",
    description_lang_key: "global_ratings",
    img: IconLogoGR,
    permissions: "globalRatings.versions.get",
    path: "/editor/gr/",
  },
  {
    id: 2,
    code: "Q",
    name: "Q",
    description_lang_key: "quartiles",
    img: IconLogoQ,
    path: "/editor/q/",
    permissions: "quartilesRatings.versions.get",
  },
  {
    id: 3,
    code: "Staff",
    name: "Staff",
    description_lang_key: "personal",
    img: IconLogoStaff,
    path: "/editor/staff/",
    permissions: ["employeeAccounting.expectations"],
  },
  {
    id: 5,
    code: "Subdivision",
    name: "Subdivision",
    description_lang_key: "subdivision",
    svg: IconLogoSubdivision,
    path: "/editor/subdivision/",
    permissions: "subdivisions.getList",
  },
  {
    id: 6,
    code: "Violation",
    name: "Violation",
    description_lang_key: "violation",
    img: IconLogoViolation,
    path: "/editor/violation/",
    permissions: "violationsTypes.get",
  },
  {
    id: 7,
    code: "ZD",
    name: "zd",
    description_lang_key: "zd",
    img: IconLogoCenter,
    path: "/editor/zd/",
    permissions: "zd.byId.get",
  },
  {
    id: 8,
    code: "Directories",
    name: "directories",
    description_lang_key: "positions_directory",
    svg: IconLogoPositionsDirectory,
    path: "/editor/directories/",
    permissions: [
      "directions.directions.get",
      "employeeAccounting.position.get",
    ],
  },
  {
    id: 9,
    code: "CatalogEducationalPrograms",
    name: "CatalogEducationalPrograms",
    description_lang_key: "catalog_educational_programs",
    svg: IconLogoCatalogEducationalPrograms,
    path: "/editor/cep/",
    permissions: [
      "employeeAccounting.curriculum.group.get",
      "employeeAccounting.curriculum.level.get",
      "employeeAccounting.curriculum.course.get",
      "employeeAccounting.curriculum.program.get",
    ],
  },
  {
    id: 10,
    code: "EditorDocumentSection",
    name: "EditorDocumentSection",
    description_lang_key: "reference_books_document_library",
    svg: NewFiles,
    path: "/editor/doc/",

    permissions: "documents.getSection",
  },
  {
    id: 11,
    code: "EditorReports",
    name: "EditorReports",
    description_lang_key: "reports",
    svg: NewFiles,
    path: "/editor/reports/",
    permissions: "indicatorGroupReports.indicatorReport.create",
  },
  //TODO: https://task.sotl.group:8443/browse/PASDILER-1639 временное скрытие ссылки на справочник
  // {
  //   id: 13,
  //   code: "InformationSystem",
  //   name: "InformationSystem",
  //   description_lang_key: "info_system",
  //   img: IconLogoInfoSystem,
  //   path: "/editor/is",
  //   role: ["admin", "adminData"],
  // },
  {
    id: 14,
    code: "EditorPhotoGallery",
    name: "EditorPhotoGallery",
    description_lang_key: "directory_photo_galleries_sections",
    svg: VideoCamera,
    permissions: "photoGallery.section.get",
    path: "/editor/photo-gallery/",
  },
  {
    id: 15,
    code: "ContractTemplates",
    name: "ContractTemplates",
    description_lang_key: "contract_templates",
    svg: NewFiles,
    path: "/editor/contract-templates/",
    permissions: ["contracts.createTpm"],
  },
  {
    id: 16,
    code: "AddressSelectionGuide",
    name: "AddressSelectionGuide",
    description_lang_key: "address_selection_guide",
    svg: NewFiles,
    path: "/editor/address_selection_guide/",
    permissions: "addressSelectionguide.get",
  },
  {
    id: 17,
    code: "EditorTrustedPersons",
    name: "EditorTrustedPersons",
    description_lang_key: "directory_trusted_persons",
    img: IconLogoStaff,
    path: "/editor/trusted_persons/",
    permissions: [
      "editor.contracts.trusted.create",
      "editor.contracts.trusted.edit",
    ],
  },
  {
    id: 18,
    code: "IvideonPlans",
    name: "IvideonPlans",
    description_lang_key: "ivideon_plans",
    svg: VideoCamera,
    path: "/editor/ivideon-plans/",
    permissions: ["ivideon.getCameraTariffs"],
  },
  {
    id: 19,
    code: "Requisites",
    name: "Requisites",
    description_lang_key: "requisites_vaz",
    svg: NewFiles,
    path: "/editor/requisites",
    permissions: [
      "contracts.changeVasReq",
      "contracts.updateVasReq",
      "contracts.deleteVasReq",
    ],
  },
  {
    id: 23,
    code: "DealerMetrics",
    name: "DealerMetrics",
    description_lang_key: "dealer_metrics",
    svg: NewFiles,
    path: "/editor/dealer-metrics/",
    permissions: "dealerindicator.metrics.get",
  },
  {
    id: 20,
    code: "BaseTariffs",
    name: "BaseTariffs",
    description_lang_key: "base_tariffs_lms",
    svg: NewFiles,
    path: "/editor/base-tariffs",
    permissions: "employeeAccounting.tariffs.get",
  },
  {
    id: 21,
    code: "DnmRoleMappings",
    name: "DnmRoleMappings",
    description_lang_key: "dnm_role_mappings",
    svg: NewFiles,
    path: "/editor/dnm-role-mappings/",
    permissions: ["dealer.getDnmRoleMappings"],
  },
  {
    id: 22,
    code: "ContestTerritories",
    name: "ContestTerritories",
    description_lang_key: "contest_territories",
    svg: NewFiles,
    path: "/editor/contest-territories/",
    permissions: ["competitiveTerritories.view"],
  },
];

// Permissions для доступа к странице Editor (из OPTIONS + дополнительные проверки на странице)
export const EDITOR_PAGE_PERMISSIONS = Array.from(
  new Set([
    "user_guides.getGuideFile",
    ...OPTIONS.flatMap((item) => {
      if (item.permissions) {
        if (typeof item.permissions === "string") return [item.permissions];
        if (Array.isArray(item.permissions)) return item.permissions;
      }
      return [];
    }),
  ]),
).sort();
